export function routes($stateProvider) {
    $stateProvider
        .state('app.formacao.areasinteresse', {
        url: '/areasinteresse',
        abstract: true,
        template: '<div ui-view></div>'
    })
        .state('app.formacao.areasinteresse.list', {
        url: '?{page:int}&{items:int}&{state:int}&order&sort&filter',
        title: 'Áreas de Interesse',
        template: require('./directory/directory.view.html'),
        controller: 'ForListAreasInteresseController',
        controllerAs: 'vm',
        role: 'formacaoVerAreasInteresse',
        params: {
            state: {
                value: 1,
                dynamic: true
            },
            page: {
                value: 1,
                dynamic: true
            },
            items: {
                value: 20,
                dynamic: true
            },
            order: {
                value: "id",
                dynamic: true
            },
            sort: {
                value: "desc",
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        }
    });
}
routes.$inject = ['$stateProvider'];
